import React, { Component } from 'react';
import "../CSS/fonts/OpenSans-Bold.eot";
import "../CSS/fonts/OpenSans-Bold.ttf";
import "../CSS/fonts/OpenSans-Regular.eot";
import "../CSS/fonts/OpenSans-Regular.ttf";
import "../CSS/fonts/OpenSans-Semibold.eot";
import "../CSS/fonts/OpenSans-Semibold.ttf";
import "../CSS/CustomStyles.css";

export default class SectionHeader extends Component {
    render() {
        return (<div className={"row mx-0 bg-white border p-3 align-items-center CA-Dashboard-head"}>
            {this.props.children}
        </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/SectionHeader.js